export default __webpack_public_path__ + "static/media/pinata.db079ebd.gif";